export default __webpack_public_path__ + "static/media/wheel-stopped.b0b05818.mp3";